import React, {Component} from 'react';
import { ListItem,} from 'material-ui/List';
import { NavLink, withRouter} from 'react-router-dom'


import {connect} from 'react-redux';
import logo from '../../../../assets/img/logo_small.png';

import Messages from '../../../../assets/img/NavIcons/Messages.png';
import Buildings from '../../../../assets/img/NavIcons/Buildings.png';
import Home from '../../../../assets/img/NavIcons/Home.png';
import Products from '../../../../assets/img/NavIcons/Products.png';
import Profile from '../../../../assets/img/NavIcons/Profile.png';
import Reports from '../../../../assets/img/NavIcons/Reports.png';

class SideMenu extends Component {
  constructor(props) {
    super(props);

    this.key = 0;

    this.mapRoutes = this.mapRoutes.bind(this);


    this.navIcons = {
      Messages,
      Buildings,
      Home,
      Products,
      Profile,
      Reports
    }

  }
  mapRoutes(key) {

        const style = {
          padding: '16px 16px 16px 55px',
          fontSize: '14px',
        }

        if(key.subRoutes) {
            this.key++;
            return <ListItem
                        key={this.key}
                        primaryText={key.title}
                        innerDivStyle={style}
                        leftIcon={<i className="material-icons">{key.icon}</i>}
                        initiallyOpen={false}
                        className="childmenu"
                        primaryTogglesNestedList={true}
                        nestedItems={ key.subRoutes.map(this.mapRoutes)}
                        />
        }else{
            this.key++
            if(key.hidden) {
              return;
            }

            let source = this.navIcons[key.icon];


            return (
              <li key={this.key}>
                <NavLink activeClassName="active" to={key.url}><img alt={key.title} src={source} /><span>{key.title}</span></NavLink>
              </li>
              )

        }


    }

  render() {

    return (
      <div>
        <div className="badge">
          <NavLink to="/"><img alt="Logo" src={logo}/></NavLink>
        </div>
        <ul className="sidebar-menu">
          {this.props.user.availableRoutes ? this.props.user.availableRoutes.map(this.mapRoutes) : ''}
        </ul>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.UserReducer
  }
}

export default withRouter(connect(mapStateToProps)(SideMenu));



// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar/Menu/index.js